import type { MoveAction, PlayData } from '../types';

/*
  What a board would save, as the play store's state stands: built by a client's play provider and handed
  to useSyncedPlaySave.
*/

export interface GameSavePayload<CellT> {
  boardId: number;
  playData: PlayData<CellT>;
  complete: boolean;
  playDuration: number;
  moveHistory: MoveAction[];
}

/**
 * The payload as of now, for a flush when the player leaves the board: a play's duration is otherwise sampled
 * only at each move, so the time since the last one would be lost, and a player could think without the clock
 * counting by leaving and coming back.
 *
 * Only for an unfinished play with moves in it. A completed play's time was fixed by its completing move, and a
 * board merely opened has nothing worth a saved play.
 */
export function withElapsedPlayTime<CellT>(p: GameSavePayload<CellT>, elapsedSeconds: number): GameSavePayload<CellT> {
  if (p.complete || p.moveHistory.length === 0 || elapsedSeconds <= p.playDuration) return p;
  return { ...p, playDuration: elapsedSeconds };
}
